module.exports = __webpack_public_path__ + "media/legacy/images/ajaxloader-589372621e7992b792d5791c809b93a8.gif";